import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router'
import type { RouteScrollPosition } from '@store'

type UseScrollRestorationParams = {
  forceScrollRestore?: boolean // 강제 스크롤 복원(중첩 라우트 상관없이 이전에 저장된 스크롤 포지션 복원)
  onSaveScrollPosition?: () => Omit<RouteScrollPosition, 'scrollPosition'> // 스크롤 포지션 외 저장하고 싶은 값 추가 저장
  onBeforeScrollRestore?: (RouteScrollPosition?: RouteScrollPosition) => void // 스크롤 복원 하기전 훅
  onScrollRestored?: (RouteScrollPosition?: RouteScrollPosition) => void // 스크롤 복원 후
}

/**
 * 라우트 간 이동 시 스크롤 위치를 저장
 */
export const useScrollRestoration = ({
  onSaveScrollPosition = () => ({}),
}: UseScrollRestorationParams = {}) => {
  const { routeScrollPositions, saveRouteScrollPosition } = useLayoutStore()

  onBeforeRouteLeave((_to, from, next) => {
    // Save scroll on route change
    if (from) {
      const options = onSaveScrollPosition()
      saveRouteScrollPosition(useGetRouteName(String(from.name)), {
        scrollPosition: window.scrollY,
        ...options,
      })
      console.log(
        `[ROUTE LEAVE] save route scroll position ${String(from.name)}:`,
        routeScrollPositions[useGetRouteName(String(from.name))]
      )
    }

    next()
  })

  onBeforeRouteUpdate((to, from, next) => {
    const options = onSaveScrollPosition()
    const toRouteName = useGetRouteName(String(to.name))
    const toRouteConfig = useGetRouteConst(toRouteName)
    console.log('to', to)
    console.log('from', from)
    console.log('scrollPositions', routeScrollPositions)
    console.log('toParentRouteNameByConfig', toRouteConfig)
    if (toRouteConfig?.isModalPage) {
      saveRouteScrollPosition(useGetRouteName(String(to.name)), {
        scrollPosition: window.scrollY,
        ...options,
      })

      saveRouteScrollPosition(useGetRouteName(String(from.name)), {
        scrollPosition: window.scrollY,
        ...options,
      })

      console.log(
        `[ROUTE UPDATE] save route scroll position ${String(to.name)}:`,
        routeScrollPositions[useGetRouteName(String(to.name))]
      )
    } else {
      saveRouteScrollPosition(useGetRouteName(String(from.name)), {
        scrollPosition: window.scrollY,
        ...options,
      })

      console.log(
        `[ROUTE UPDATE] save route scroll position ${String(from.name)}:`,
        routeScrollPositions[useGetRouteName(String(from.name))]
      )
    }

    next()
  })
}
